import React from 'react';
import './CustomButton.scss';

interface CustomButtonProps {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'light' | 'dark';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const CustomButton = React.forwardRef<HTMLButtonElement, CustomButtonProps>(({
  variant = 'primary',
  color,
  size = 'md',
  children,
  onClick,
  disabled = false,
  className = '',
  type = 'button',
  icon,
  style
}, ref) => {
  let variantClass = `custom-btn--${variant}`;
  
  if (variant === 'outline' && color) {
    variantClass = `custom-btn--outline-${color}`;
  } else if (color && variant !== 'outline') {
    variantClass = `custom-btn--${color}`;
  }
  
  const buttonClass = `custom-btn ${variantClass} custom-btn--${size} ${className}`.trim();

  return (
    <button
      ref={ref}
      type={type}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      {children && <span className="btn-text">{children}</span>}
    </button>
  );
});

CustomButton.displayName = 'CustomButton';

export default CustomButton;